<template>
  <SiteNavbar :empresa="logo"/>
  <TableEventos :empresa="empresa" :telefone="telefone" />
</template>

<script>
import TableEventos from '@/components/TableEventos.vue';
import SiteNavbar from '@/components/SiteNavbar.vue'
export default {
  name: 'SiteMemorial',
  components: {
    TableEventos, SiteNavbar
  },
  data() {
    return {
      empresa: "Memorial Parque Maceio",
      logo: "memorialparque",
      telefone: "82 9122-9510"
    };
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
